import { Head, Link } from "@inertiajs/react";
import AdminLayout from "@/components/admin/AdminLayout";
import { Card } from "@/components/ui/card";
import StatusBadge from "@/components/shared/StatusBadge";

export default function Index({ applications, counts, filter }) {
  const tabs = [
    { key: "all",      label: "All",      href: "/admin/school_applications" },
    { key: "pending",  label: "Pending",  href: "/admin/school_applications?status=pending" },
    { key: "approved", label: "Approved", href: "/admin/school_applications?status=approved" },
    { key: "rejected", label: "Rejected", href: "/admin/school_applications?status=rejected" },
  ];

  return (
    <AdminLayout
      eyebrow="Review"
      title="School applications"
    >
      <Head title="Admin · Applications" />

      {/* ── Filter tabs ────────────────────────────────── */}
      <div className="flex flex-wrap gap-2 mb-6 border-b border-border pb-4">
        {tabs.map((tab) => (
          <Link
            key={tab.key}
            href={tab.href}
            className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
              filter === tab.key
                ? "bg-primary text-primary-foreground"
                : "bg-secondary/60 text-muted-foreground hover:text-foreground hover:bg-secondary"
            }`}
          >
            {tab.label}
            <span className={`inline-flex items-center justify-center min-w-[1.5rem] h-5 rounded-full text-[11px] font-mono tabular-nums ${
              filter === tab.key
                ? "bg-primary-foreground/20 text-primary-foreground"
                : "bg-background text-muted-foreground"
            }`}>
              {counts[tab.key]}
            </span>
          </Link>
        ))}
      </div>

      {/* ── Applications table ────────────────────────── */}
      {applications.length === 0 ? (
        <Card className="p-10 text-center">
          <p className="text-muted-foreground">No applications in this view.</p>
        </Card>
      ) : (
        <Card className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-background border-b border-border">
              <tr className="text-xs uppercase tracking-wider text-muted-foreground">
                <th className="text-left px-4 py-3 font-medium">School</th>
                <th className="text-left px-4 py-3 font-medium">Applicant</th>
                <th className="text-left px-4 py-3 font-medium">Province</th>
                <th className="text-left px-4 py-3 font-medium">Students</th>
                <th className="text-left px-4 py-3 font-medium">Campaign planning</th>
                <th className="text-left px-4 py-3 font-medium">Status</th>
                <th className="text-right px-4 py-3 font-medium">Submitted</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {applications.map((app) => (
                <tr key={app.id} className="hover:bg-secondary/40 transition-colors">
                  <td className="px-4 py-3">
                    <Link href={app.review_path} className="font-medium text-foreground hover:text-primary">
                      {app.school_name}
                    </Link>
                    {app.city && <p className="text-xs text-muted-foreground">{app.city}</p>}
                  </td>
                  <td className="px-4 py-3">
                    <p className="text-foreground">{app.applicant_name}</p>
                    <p className="text-xs text-muted-foreground">{app.applicant_email}</p>
                  </td>
                  <td className="px-4 py-3 text-muted-foreground">{app.province}</td>
                  <td className="px-4 py-3 text-muted-foreground font-mono tabular-nums">
                    {app.estimated_students ?? "—"}
                  </td>
                  <td className="px-4 py-3">
                    <p>{app.payment_processor_label}</p>
                    <p className="text-xs text-muted-foreground">Dates: {app.campaign_dates_label}</p>
                  </td>
                  <td className="px-4 py-3">
                    <StatusBadge status={app.status} />
                  </td>
                  <td className="px-4 py-3 text-right text-xs text-muted-foreground whitespace-nowrap">
                    {app.submitted_ago}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </AdminLayout>
  );
}

